
import { Container, TextStyle, Text, Graphics, Sprite } from 'pixi.js'
import Button from './ButtonSolid.js'
import ButtonSmall from './ButtonSmall.js'
export default class RoundSummary extends Container {
    constructor(...arg) {
        super(...arg);

        this.round = 1;
        this.interactive = true;
        this.on('pointerdown', this.close_onClick.bind(this));


        // //background
        // var popupBackground = new Graphics();
        // popupBackground.beginFill(0x000000);
        // //popupBackground.drawRect(-500,-500, 1000, 1000);
        // popupBackground.alpha = 0.1;
        // this.addChild(popupBackground);

        this.container = new Container();
        this.addChild(this.container);

        var styleTitle = new TextStyle({
            fontFamily: 'Arial',
            fontSize: 32 * 2,
            fill: '#FFFFFF',
            wordWrap: true,
            wordWrapWidth: 800,
            align: 'center'
        });
        var styleLarge = new TextStyle({
            fontFamily: 'Arial',
            fontSize: 32 * 2,
            fill: '#FFFFFF'
        });
        var styleNormal = new TextStyle({
            fontFamily: 'Arial',
            fontSize: 24 * 2,
            fill: '#FFFFFF',
            align: 'center'
        });
        let styleMedium = new TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 16 * 2,
            fill: '#FFFFFF'
        });

        let styleSmall = new TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 10 * 2,
            fill: '#FFFFFF'
        });

        this.color = 0x479ACE;// or 0x479ACE or 0xC03500
        //titleBox
        var titleBox = new Graphics();
        titleBox.beginFill(this.color);
        titleBox.drawRoundedRect(0, 0, 500, 80, 10);
        // titleBox.beginFill(0x333333);
        // titleBox.drawRoundedRect(0, 400, 550, 80, 10);
        this.container.addChild(titleBox);


        // //background
        // var graphics = new Graphics();
        // graphics.beginFill(0x333333);
        // graphics.lineStyle(0, 0xFFFFFF, 1);
        // // graphics.drawRect(0, 0, 500, 500);
        // graphics.drawRoundedRect(0, 0, 250, 350, 10);
        // graphics.alpha = 1;
        // this.container.addChild(graphics);



        //background
        var graphics = new Graphics();
        graphics.beginFill(0x333333);
        graphics.drawRect(0, 50, 500, 350);
        this.container.addChild(graphics);


        //textTitle
        this.textTitle = new Text('Round', styleTitle);
        this.textTitle.x = 500/2;
        this.textTitle.y = 10;
        this.textTitle.anchor.set(0.5, 0);
        this.textTitle.scale.set(0.5);
        this.container.addChild(this.textTitle);

        //contentContainer 250
        this.contentContainer = new Container();
        this.contentContainer.x = 125;
        this.container.addChild( this.contentContainer);

        //textHeader1
        this.textHeader1 = new Text('', styleSmall);
        this.textHeader1.x = 250;
        this.textHeader1.y = 55;
        //this.textHeader1.anchor.set(0.5, 0);
        this.textHeader1.scale.set(0.5);
        this.contentContainer.addChild(this.textHeader1);

        //textHeader2
        this.textHeader2 = new Text('Player wins!', styleNormal);
        this.textHeader2.x = 125;
        this.textHeader2.y = 60;
        this.textHeader2.anchor.set(0.5, 0);
        this.textHeader2.scale.set(0.5);
        this.contentContainer.addChild(this.textHeader2);

        //textRow1Col1
        this.textRow1Col1 = new Text('Computer', styleNormal);
        this.textRow1Col1.x = 120;
        this.textRow1Col1.y = 110;
        this.textRow1Col1.anchor.set(1.0, 0);
        this.textRow1Col1.scale.set(0.5);
        this.contentContainer.addChild(this.textRow1Col1);


        //textHeader3
        this.textHeader3 = new Text('Deadwood', styleSmall);
        this.textHeader3.x = 120;
        this.textHeader3.y = 135;
        this.textHeader3.anchor.set(1.0, 0);
        this.textHeader3.scale.set(0.5);
        this.contentContainer.addChild(this.textHeader3);



        //textRow1Col3
        this.textRow1Col3 = new Text('16', styleNormal);
        this.textRow1Col3.x = 170;
        this.textRow1Col3.y = 110;
        this.textRow1Col3.anchor.set(0.5, 0);
        this.textRow1Col3.scale.set(0.5);
        this.contentContainer.addChild(this.textRow1Col3);

        //textRow1Col1
        this.textRow2Col1 = new Text('Player', styleNormal);
        this.textRow2Col1.x = 120;
        this.textRow2Col1.y = 150;
        this.textRow2Col1.anchor.set(1.0, 0);
        this.textRow2Col1.scale.set(0.5);
        this.contentContainer.addChild(this.textRow2Col1);

        //textHeader3
        this.textHeader3 = new Text('Deadwood', styleSmall);
        this.textHeader3.x = 120;
        this.textHeader3.y = 175;
        //this.textHeader3.anchor.set(0.5, 0);
        this.textHeader3.anchor.set(1.0, 0);
        this.textHeader3.scale.set(0.5);
        this.contentContainer.addChild(this.textHeader3);


        //textRow1Col3
        this.textRow2Col3 = new Text('16', styleNormal);
        this.textRow2Col3.x = 170;
        this.textRow2Col3.y = 150;
        this.textRow2Col3.anchor.set(0.5, 0);
        this.textRow2Col3.scale.set(0.5);
        this.contentContainer.addChild(this.textRow2Col3);

        //textRow2Col1
        this.textRow3Col1 = new Text('Undercut', styleNormal);
        this.textRow3Col1.x = 120;
        this.textRow3Col1.y = 190;
        this.textRow3Col1.anchor.set(1.0, 0);
        this.textRow3Col1.scale.set(0.5);
        this.contentContainer.addChild(this.textRow3Col1);

        //textRow2Col3
        this.textRow3Col3 = new Text('4', styleNormal);
        this.textRow3Col3.x = 170;
        this.textRow3Col3.y = 190;
        this.textRow3Col3.anchor.set(0.5, 0);
        this.textRow3Col3.scale.set(0.5);
        this.contentContainer.addChild(this.textRow3Col3);

        //textRow2Col1
        this.textRow4Col1 = new Text('Gin', styleNormal);
        this.textRow4Col1.x = 120;
        this.textRow4Col1.y = 230;
        this.textRow4Col1.anchor.set(1.0, 0);
        this.textRow4Col1.scale.set(0.5);
        this.contentContainer.addChild(this.textRow4Col1);

        //textRow2Col3
        this.textRow4Col3 = new Text('4', styleNormal);
        this.textRow4Col3.x = 170;
        this.textRow4Col3.y = 230;
        this.textRow4Col3.anchor.set(0.5, 0);
        this.textRow4Col3.scale.set(0.5);
        this.contentContainer.addChild(this.textRow4Col3);


        //line background
        var line = new Graphics();
        line.lineStyle(2, 0xFFFFFF, 2);
        line.moveTo(10, 100);
        line.lineTo(240, 100);
        this.contentContainer.addChild(line);


        //line background
        var line = new Graphics();
        line.lineStyle(2, 0xFFFFFF, 2);
        line.moveTo(10, 270);
        line.lineTo(240, 270);
        this.contentContainer.addChild(line);

        //line background
        var line = new Graphics();
        line.lineStyle(2, 0xFFFFFF, 2);
        line.moveTo(140, 100);
        line.lineTo(140, 305);
        this.contentContainer.addChild(line);

        //textRow1Col1
        this.textRow5Col1 = new Text('Total', styleNormal);
        this.textRow5Col1.x = 120;
        this.textRow5Col1.y = 280;
        this.textRow5Col1.anchor.set(1.0, 0);
        this.textRow5Col1.scale.set(0.5);
        this.contentContainer.addChild(this.textRow5Col1);



        //textRow1Col3
        this.textRow5Col3 = new Text('16', styleNormal);
        this.textRow5Col3.x = 170;
        this.textRow5Col3.y = 280;
        this.textRow5Col3.anchor.set(0.5, 0);
        this.textRow5Col3.scale.set(0.5);
        this.contentContainer.addChild(this.textRow5Col3);


        //Next Round button
        this.btnNext = new Button("Play", 0x479ACE, 230);
        this.btnNext.x = 10;
        this.btnNext.y = 325;
        this.btnNext.interactive = true;
        this.btnNext.on('pointerdown', this.btnNext_onClick.bind(this));
        this.contentContainer.addChild(this.btnNext);

        //rematch indicator ready
        this.btnHighlightReady = new Graphics();
        this.btnHighlightReady.lineStyle(2, 0xFFFF00, 3);
        this.btnHighlightReady.drawRoundedRect(10, 325, 230, 60, 10);
        this.contentContainer.addChild(this.btnHighlightReady);



    }
    update() {
        let isDirty = false;
        if (this.btnHighlightReady.visible !== this.readyPlayer1 || this.readyPlayer2) isDirty = true;

        this.btnHighlightReady.visible = this.readyPlayer1 || this.readyPlayer2;

        this.isDirty = isDirty;
    }
    populate(roundDetails) {
        if(!roundDetails) roundDetails = {};


        this.textHeader2.text =  roundDetails.results || "Player wins";
        this.textRow1Col1.text =  roundDetails.player1Name || "Player 1";
        this.textRow2Col1.text =  roundDetails.player2Name || "Player 2";

        
        this.textRow1Col3.text = roundDetails.player1Deadwood || 0;
        this.textRow2Col3.text = roundDetails.player2Deadwood || 0;
        this.textRow3Col3.text = roundDetails.undercutPoints || 0;
        this.textRow4Col3.text = roundDetails.ginPoints || 0;
        this.textRow5Col3.text = roundDetails.totalPoints  || 0;


    }
    updateLayout() {
        let scoreSummary = this.scoreSummary;
        let analyzeScore = this.analyzeScore;

        let analyzeSummary = 'Hand Score: ' + (analyzeScore || 100);
        this.textAnalyzeSummary.text = analyzeSummary;
        //this.btnAnalyze.text = analyzeScore;

        this.round = scoreSummary.round;
        if (!scoreSummary.hasOwnProperty('player1')) scoreSummary["player1"] = {};
        if (!scoreSummary.hasOwnProperty('player2')) scoreSummary["player2"] = {};

        this.textHeader2.text = scoreSummary["player1"].name || "You";
        this.textRow1Col2.text = (scoreSummary["player1"].starter || 0);
        this.textRow2Col2.text = (scoreSummary["player1"].play || 0);
        this.textRow3Col2.text = scoreSummary["player1"].hand || 0;
        this.textRow4Col2.text = scoreSummary["player1"].crib || 0;
        this.textRow5Col2.text = scoreSummary["player1"].total || 0;

        this.textHeader3.text = scoreSummary["player2"].name || "Computer";
        this.textRow1Col3.text = (scoreSummary["player2"].starter || 0);
        this.textRow2Col3.text = (scoreSummary["player2"].play || 0);
        this.textRow3Col3.text = scoreSummary["player2"].hand || 0;
        this.textRow4Col3.text = scoreSummary["player2"].crib || 0;
        this.textRow5Col3.text = scoreSummary["player2"].total || 0;
    }
    btnNext_onClick(event) {
        if (this.onNext) {
            this.onNext();
        }
        event.stopPropagation();
        //this.visible = false;
        //this.parent.isDirty = true;
        // this.parent.isDirty = true;
        // this.parent.removeChild(this);
       

    }
   
    close_onClick(event) {
        if (this.onClose) {
            this.onClose();
        }
        event.stopPropagation();
        //this.visible = false;
        //this.parent.isDirty = true;
        //  this.parent.isDirty = true;
        //   this.parent.removeChild(this);
        this.btnNext_onClick(event);
    }
}